// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/AuditTool/index.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s2 = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/AuditTool/index.tsx");
  import.meta.hot.lastModified = "1732036225890.8074";
}
// REMIX HMR END

import { Fragment, Suspense, useEffect, useState } from "react";
import { Await, useLoaderData, useLocation, useNavigation, useSearchParams } from "@remix-run/react";
import { schema } from "~/routes/audit";
import ContentWrapper from "~/components/ContentWrapper";
import Form from "~/components/forms/Form";
import Button from "~/components/Button";
import SpeedTestDropdown from "./SpeedTestDropdown";
import AuditResult from "./AuditResult";
import { buildSearchParams } from "./utils";
import Heading from "~/components/Heading";
const formatAudit = audit => {
  if (!audit || audit.error) return null;
  return {
    psi: audit.psi ? audit.psi.data.lighthouseResult : undefined,
    crux: audit.crux ? audit.crux.coreWebVitals : undefined,
    opengraph: audit.opengraph ? audit.opengraph.cards : undefined
  };
};
export default function AuditTool() {
  _s2();
  var _s = $RefreshSig$();
  // @ts-expect-error - Loader data is not typed correctly because defer is bug at this Remix version
  const {
    audit
  } = useLoaderData();
  const [searchParams, setSearchParams] = useSearchParams();
  const [hasAuditError, setHasAuditError] = useState(false);
  const navigation = useNavigation();
  const location = useLocation();
  const loading = navigation.state !== "idle" && navigation.location.pathname === location.pathname;
  return <Fragment>
      <ContentWrapper spacing="primary" className="w-full bg-white flex-col items-center">
        <hgroup className="w-full">
          <Heading tag="h2" className="text-center">
            Check your website health
          </Heading>
          <p className="text-lg text-neutral-600">
            Submit your URL below to initiate a comprehensive website health
            assessment. Just select one of the options for your site.
          </p>
        </hgroup>
        <Form schema={schema} mode="onBlur" action="/audit" className="w-full" hiddenFields={["intent"]} values={{
        url: searchParams.get("url") || ""
      }} errors={hasAuditError ? {
        url: ["URL not found. Try again."]
      } : undefined} onSubmit={e => {
        e.preventDefault();
      }}>
          {({
          Field,
          Errors,
          setValue,
          getValues,
          setError,
          clearErrors
        }) => {
          const handleAudit = intent => {
            setHasAuditError(false);
            setValue("intent", intent);
            const url = getValues("url");
            if (!url) {
              setError("url", {
                message: "This field is required.",
                type: "required"
              });
              return;
            }
            const urlParsed = schema.pick({
              url: true
            }).safeParse({
              url
            });
            if (!urlParsed.success) {
              setError("url", {
                message: "Invalid URL. Try again",
                type: "pattern"
              });
              return;
            }
            const params = buildSearchParams({
              url: urlParsed.data.url,
              intent
            });
            setSearchParams(params, {
              preventScrollReset: true
            });
          };
          return <Fragment>
                <fieldset className="w-full flex flex-col md:flex-row mt-7 gap-6">
                  <Field className="grow" name="url">
                    {({
                  SmartInput,
                  Errors
                }) => <Fragment>
                        <SmartInput placeholder="Website URL" />
                        <Errors />
                      </Fragment>}
                  </Field>
                  <Field name="intent" />
                  <div className="flex gap-3 grow md:grow-0 md:children:max-h-[58px]">
                    <SpeedTestDropdown onSelectOption={option => handleAudit(option)} />
                    <Button type="button" variant="tertiary" className="shrink-0 grow md:grow-0 flex items-center" onClick={() => handleAudit("opengraph")}>
                      Meta Tags
                    </Button>
                  </div>
                </fieldset>
                <Errors />
              </Fragment>;
        }}
        </Form>
      </ContentWrapper>
      <Suspense fallback={<AuditResult audit={undefined} isLoading={true} isStreaming />}>
        <Await resolve={audit}>
          {_s(audit => {
          _s();
          useEffect(() => {
            if (audit?.error) {
              setHasAuditError(true);
            }
          }, [audit]);
          return <AuditResult audit={formatAudit(audit)} isLoading={loading} reportId={audit?.reportId} />;
        }, "OD7bBpZva5O2jO+Puf00hKivP7c=")}
        </Await>
      </Suspense>
    </Fragment>;
}
_s2(AuditTool, "DuZD5YIZsf6Pz0LCagtoT1kxZW4=", false, function () {
  return [useLoaderData, useSearchParams, useNavigation, useLocation];
});
_c = AuditTool;
var _c;
$RefreshReg$(_c, "AuditTool");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;